/**
 * Where an account lands after signing in. Committee and reviewer accounts have
 * their own desk; everyone else goes to the proposal wizard.
 *
 * Accepts either shape the app holds a person in: the raw profile row from the
 * API or the mapped Researcher, so sign-in and routing share one rule.
 */
export interface RoleFlags {
  isSrcAdmin: boolean;
  isIrbAdmin: boolean;
  isReviewer: boolean;
}

export interface ApiRoleFlags {
  IsSrcAdmin: boolean;
  IsIrbAdmin: boolean;
  IsReviewer: boolean;
}

function normalise(flags: RoleFlags | ApiRoleFlags): RoleFlags {
  if ('IsSrcAdmin' in flags) {
    return {
      isSrcAdmin: flags.IsSrcAdmin,
      isIrbAdmin: flags.IsIrbAdmin,
      isReviewer: flags.IsReviewer
    };
  }
  return flags;
}

export function homeFor(flags: RoleFlags | ApiRoleFlags): string {
  const role = normalise(flags);
  if (role.isSrcAdmin || role.isIrbAdmin) return '/committee';
  if (role.isReviewer) return '/reviewer';
  return '/dashboard';
}

/**
 * The name to greet someone by. Staff names here routinely carry an honorific
 * ("Dr. Sania Khaliq", "Prof. Dr. Nadia Rehman"), and taking the first word
 * gives "Dr." — so skip those and use the first real name instead.
 */
const HONORIFICS = ['dr', 'dr.', 'prof', 'prof.', 'mr', 'mr.', 'mrs', 'mrs.', 'ms', 'ms.', 'miss'];

export function firstNameOf(fullName: string | null | undefined): string {
  const parts = (fullName ?? '')
    .split(/\s+/)
    .map((part) => part.trim())
    .filter(Boolean);

  const name = parts.find((part) => !HONORIFICS.includes(part.toLowerCase()));
  return name ?? '';
}
